export const environment = {
  production: true,
  tenantName: 'univnebrmedcntr',
  appInsights: {
    instrumentationKey: '56c71ce7-1145-47ad-9802-8228b4d6f5f1',
  },
  azureConnection: 'Endpoint=https://iexcelnowmessaging.service.signalr.net;AccessKey=b+rAxObrBuooGoNOF3XPgzRSvviOLDmSM7ujCHxJpkM=;Version=1.0;'
};

